import React from "react"
import { Users, Flame, MessagesSquare, Trash2 } from "lucide-react"
import { cn } from "src/utils/cn"

// The ROI strip: how many leads the engine scored, how many it surfaced as
// genuine, how many are still being qualified, and how much junk it filtered.
// This is the "what the AI did for you" story the queue is built to sell.
export function QueueStats({ stats }) {
  if (!stats) return null

  const cards = [
    { label: "Scored by AI", value: stats.total_scored, Icon: Users, tone: "slate" },
    { label: "Qualified (Hot + Warm)", value: stats.qualified, sub: `${stats.qualified_pct}% of scored`, Icon: Flame, tone: "emerald" },
    { label: "In conversation", value: stats.conversing, Icon: MessagesSquare, tone: "indigo" },
    { label: "Junk filtered", value: stats.junk, Icon: Trash2, tone: "amber" },
  ]

  const tones = {
    slate:   "text-slate-600 bg-slate-50",
    emerald: "text-emerald-600 bg-emerald-50",
    indigo:  "text-indigo-600 bg-indigo-50",
    amber:   "text-amber-600 bg-amber-50",
  }

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {cards.map(({ label, value, sub, Icon, tone }) => (
        <div key={label} className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="flex items-center justify-between">
            <span className="text-[12px] font-medium text-slate-500">{label}</span>
            <span className={cn("flex h-7 w-7 items-center justify-center rounded-lg", tones[tone])}>
              <Icon className="h-4 w-4" />
            </span>
          </div>
          <div className="mt-1.5 text-2xl font-bold tabular-nums text-slate-900">{value ?? 0}</div>
          {sub && <div className="text-[11px] text-slate-400">{sub}</div>}
        </div>
      ))}
    </div>
  )
}
